export default function(el) {
    const header = document.querySelector(el);
    document.addEventListener('scroll', () => {
        if(window.pageYOffset > 200) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });
}